import { UnityBridge } from '@Context/common/general/context';
import { TextField, TextFieldProps } from '@mui/material';
import { useEffect } from 'react';

function getXPathForElement(element: any) {
  const idx: any = (sib: any, name: any) =>
    sib
      ? idx(sib.previousElementSibling, name || sib.localName) +
        (sib.localName === name)
      : 1;
  const segs: any = (elm: any) =>
    !elm || elm.nodeType !== 1
      ? ['']
      : elm.id && document.getElementById(elm.id) === elm
      ? [`id("${elm.id}")`]
      : [
          ...segs(elm.parentNode),
          `${elm.localName.toLowerCase()}[${idx(elm)}]`,
        ];
  return segs(element).join('/');
}

function getScreenCordinates(obj: any) {
  var p = {x:0,y:0};
  p.x = obj.offsetLeft;
  p.y = obj.offsetTop;
  while (obj.offsetParent) {
    p.x = p.x + obj.offsetParent.offsetLeft;
    p.y = p.y + obj.offsetParent.offsetTop;
    if (obj === document.getElementsByTagName('body')[0]) {
      break;
    } else {
      obj = obj.offsetParent;
    }
  }
  return p;
}

function isTextInputType(props: TextFieldProps): boolean {
  if (props.select) return false; // If it's a select field, it's not a text input
  if (!props.type) return true; // If no type specified, assume it's a text input
  const textTypes = ['text', 'email', 'password', 'search', 'tel', 'url', 'number'];
  return textTypes.includes(props.type.toLowerCase());
}

export default (props: TextFieldProps) => {

  const SendFocusUnityEvent = (event: any) => {
    if (UnityBridge && isTextInputType(props)) {
      UnityBridge.dispatchWebEvent({
        type: UnityBridge.OutgoingWebEvents.TextFieldFocused,
        payload: event ? {
          x_path: getXPathForElement(event.target),
          screen_position: getScreenCordinates(event.currentTarget),
          element_type: event.target.getAttribute('type'),
        } : {},
      });
    }
  }

  const SendBlurUnityEvent = (event: any) => {
    if (UnityBridge && isTextInputType(props)) {
      UnityBridge.dispatchWebEvent({
        type: UnityBridge.OutgoingWebEvents.TextFieldBlurred,
        payload: event ? {
          x_path: getXPathForElement(event.target),
          screen_position: getScreenCordinates(event.currentTarget),
          element_type: event.target.getAttribute('type'),
        } : {},
      });
    }
  }

  const SendControllerHapticsEvent = () => {
    if (UnityBridge) {
      UnityBridge.dispatchWebEvent({
        type: UnityBridge.OutgoingWebEvents.TriggerHaptics,
        payload: {
          frequency: 0.25,
          amplitude: 0.1,
          duration: 0.15
        },
      });
    }
  }

  const onFocusHandler = (event: any, ...focusArgs: any[]) => {
    SendFocusUnityEvent(event);
    SendControllerHapticsEvent();
    if(props.onFocus) props.onFocus(event, ...(focusArgs as []));
  };

  const onBlurHandler = (event: any, ...blurArgs: any[]) => {
    SendBlurUnityEvent(event);
    if(props.onBlur) props.onBlur(event, ...(blurArgs as []));
  };

  useEffect(()=> {
    // Auto focus - force focus unity event to prompt keyboard
    if(props.autoFocus) {
      SendFocusUnityEvent(undefined);
    }
  }, []);

  return (
    <TextField {...props} onFocus={onFocusHandler} onBlur={onBlurHandler} />
  );
};
